import MergedImagesWrapper from "./MergedImagesWrapper";
import usePresentSelector from './usePresentSelector';
import measuredTextWidth from './measuredTextWidth';
import React, { useMemo, useEffect, useState, createRef } from 'react';

import ImageFetchFailed from './ImageFetchFailed';

import { useDispatch } from 'react-redux';
import CropPreview from './CropPreview';

import InvertColorsIcon from '@material-ui/icons/InvertColors';
import InvertColorsOffIcon from '@material-ui/icons/InvertColorsOff';

import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import DeleteIcon from '@material-ui/icons/HighlightOff';
import A from './ActionCreators';
import G from './Getters';
import C from './Constants';

import imageMap from './imageMap';
import MergedImages from './MergedImages';
import useElementDims from './useElementDims';

function CropWrapper({
  forceSingleChannel,
  filterId,
  mediaId,
  canClickToRetryDownload,
  stack,
  imageSetId,
  imageId,
  atnIdList, 
  width, 
  pxHeight,
  gridCellId, 
  temporaryAdjustments,
  htmlImageId,
  htmlImageClipDivId,
  imgRef,
  annotation,
  inlineCrop,
  fromImageManagement,
  version="raw-png",
}){

  version = version || C.DEFAULT_PROCESSED_IMAGE_VERSION;

  const toDraw = useMemo(() => ([{imageId, channelId: "default"}]), [imageId])

  let versionToSwitchTo = usePresentSelector(state => {

    if( state.media[imageId]["raw-png"]?.localBlobUrl ){
      return "raw-png";
    }

    if( state.media[imageId].raw?.localBlobUrl ){
      return "raw";
    }

  })

  if( versionToSwitchTo ){
    version = versionToSwitchTo;
  }

  let fetchStatus = usePresentSelector(state => {
    let status = G.getMediaFetchStatus(state,{imageId,version});



    if( status === "none" && version === "raw" ){


      let devShowUrlUpoads = true;
      if( process.env.NODE_ENV === "development" && devShowUrlUpoads ){
        version = "raw";
      }
      status = G.getMediaFetchStatus(state,{imageId,version});
    }
    return status;
  })



  let dispatch = useDispatch();

  if( !fetchStatus || fetchStatus === "none" ){
    console.log("Fetching images.");
    dispatch(A.fetchImages({
      imageSpecList:[{version,imageId}]
    }))
  }


  let atns = usePresentSelector(state => state.data.annotations);


  imageId = usePresentSelector(state => {

    if( !imageId && imageSetId ){
      return G.getImageSetFigureImage(state,{imageSetId})
    }else{
      return imageId;
    }
  })

  //const [ wrapperWidth, setWrapperWidth ] = useState(width);

  const wrapperRef = createRef();


  //useEffect(() => {

  //  /* this makes sure that 
  //   * changes in container width prop
  //   * are rendered
  //   */

  //  if( width !== wrapperWidth ){
  //    console.log("setting wrapper width...");
  //    console.log(`(${width},${wrapperWidth})`);
  //    setWrapperWidth(width);
  //  }
  //},[width])

  const crop = {
    top:0,
    left:0,
    height:1,
    width:1,
    rotation:0,
  }

  const wrapperDims = useElementDims(wrapperRef);

  let wrapperWidth = width ?? wrapperDims?.width;

  let {imageRecord,src} = usePresentSelector(state => {
    let imageRecord = state.data.imageUploads[imageId];

    let src;
    if( !mediaId ){


      let fallBackOnRaw;
      if( process.env.NODE_ENV === "development" ){
        fallBackOnRaw = true;
      }

      src = G.getImageRecordUrl(state,{imageId,version,fallBackOnRaw});
    }else{
      src = state.media?.[mediaId]?.[version]?.localBlobUrl;
    }


    let queryNoResults = !src;
    if( queryNoResults ){

      let imageIdMediaContainer = state.media[ imageId ];
      if( !imageIdMediaContainer ){
        debugger;
      }
      let mediaContainerValues = Object.values(imageIdMediaContainer)

      let imagesInImageMap = mediaContainerValues.filter(
        ({localBlobUrl}) => {
          return (localBlobUrl in imageMap)
        }
      );

      let { localBlobUrl } = imagesInImageMap[0] || {}; 
      return { imageRecord, src:imageMap[ localBlobUrl ] }
    }

    return { imageRecord, src }
  });


  /*

  if( !src ){
    return <div style={{color:'red',fontWeigth:'bold'}}>
      {mediaId ? "Loading..." : "No image found (src, mediaId are both falsy)."}
    </div>
  }
  */

  //let inverted = imageRecord?.adjustments.inverted;



  if( !src === true ){
    let loadingText ="Loading...";
    let textWidth = measuredTextWidth(loadingText,8);

    let loadingContent;

    if(  textWidth >= wrapperWidth ){
      loadingContent = <HourglassEmptyIcon style={{fontSize:14}}/> 
    }else if( fetchStatus === "pending"){
      loadingContent = (
        <div item={"image-fetch-status-text"} itemFetchStatus={"pending"}>
          Loading...
        </div>
      )

    }else if( fetchStatus === "corrupt" ){
      loadingContent = <ImageFetchFailed {...{
        message:"Resource not found.",
        imageId
      }}/>
    }else if( fetchStatus === "failed" ){
      loadingContent = <ImageFetchFailed {...{
        canClickToRetryDownload,
        imageId
      }}/>
    }
    return (
      <div style={{fontSize:8,border:'1px solid #ddd', 
        height:'100%',
        width:'100%', 
        textAlign:'center',
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
        }}>
        {loadingContent}
      </div>
    )
  }

  if( atnIdList && atnIdList[0] && atns[atnIdList[0]] === undefined ){
    return <div style={{color:'red'}}><b>{"Deleted annotation: " +atnIdList[0]}</b></div>
  }


  if( forceSingleChannel ){
    return (
      <>

        <div
          type={"crop-boundary"}
          imageId={imageId}
          ref={wrapperRef}
          style={{
            position:'relative', 
            height:pxHeight,
            //transform:'scaleX(-1)',
          }}>


          <CropPreview
            filterId={filterId}
            mediaId={mediaId}
            imageId={imageId}
            crop={inlineCrop||crop}
            annotation={annotation}
            imgRef={imgRef}
            temporaryAdjustments={temporaryAdjustments}
            parentWidth={wrapperWidth}
            htmlImageId={htmlImageId}
            htmlImageClipDivId={htmlImageClipDivId}
            imageRecord={imageRecord}
            src={src}
          />


        </div>


      </>
    )
  }

  if( width ){
    console.log("crop",inlineCrop);
    console.log("CWRAPPER ("+inlineCrop.annotationId, width, pxHeight);
  }

  

  return (
    <MergedImagesWrapper height={pxHeight} width={width} toDraw={toDraw} crop={inlineCrop} />
  );

  


}

export default React.memo(CropWrapper);
